import React, { memo } from "react";

function Label({ children, error, className, disabled, required }) {
  return (
    <div
      className={`${className ?? ""} font-medium text-sm my-1 ${
        children == "-" ? "invisible" : ""
      } ${error ? "text-danger" : ""}`}
    >
      {children}{" "}
      {disabled ? null : required && <span className="orange_color">*</span>}
    </div>
  );
}

export default memo(Label);
